import React from 'react';
import CustomerPortfolioB from 'components/Tvendo/Sale/DataMaster/CustomerPortfolioBureau/List.js';

export default function () {
  return <CustomerPortfolioB />;
}
